/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "../ui/sheet";

import { Button } from "../ui/button";
import ContactDialog from "../ContactDialog";
import Link from "next/link";
import { Menu } from "lucide-react";
import StoneIcon from "../StoneIcon";
import StoneLogo from "../StoneLogo";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import { useState } from "react";

export default function MobileMenu({ navItems }: { navItems: any }) {
  const [isSheetOpen, setSheetOpen] = useState(false);
  const pathName = usePathname();

  const isPublic = pathName.includes("/public");
  const isHome = pathName == "/";

  return (
    <Sheet open={isSheetOpen} onOpenChange={setSheetOpen}>
      <SheetTrigger asChild className="bg-transparent">
        <Button
          variant="outline"
          size={isHome ? "default" : "icon"}
          className={cn(
            isHome && "p-0",
            "lg:hidden border-none! bg-transparent!",
          )}
        >
          <span className="flex items-center gap-2">
            {isHome && <StoneLogo className="w-20" />}
            {isPublic && (
              <>
                <StoneLogo className="w-20" />
              </>
            )}
            {!isHome && !isPublic && (
              <>
                <Menu className="w-7 h-7 pl-1 opacity-80" /> <StoneIcon />
              </>
            )}
            <span className="sr-only">Toggle navigation menu</span>
          </span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" aria-describedby={undefined}>
        <SheetTitle className="sr-only">Navigation menu</SheetTitle>
        <Link
          href="/"
          className="flex items-center gap-2 pb-4 border-b"
          prefetch={false}
        >
          <StoneLogo />
        </Link>
        <div className="grid gap-4 py-6">
          {navItems[0]?.items.filter((item: any) => !isPublic || item.link !== "/version-history").map((item: any, index: number) => (
            <div key={`$right_nav_${index}`}>
              {item.link === "/contact" ? (
                <ContactDialog>
                  <button
                    className="flex w-full items-center py-2 text-lg font-semibold"
                    onClick={() => setSheetOpen(false)}
                  >
                    {item.title}
                  </button>
                </ContactDialog>
              ) : (
                <Link
                  href={item.link ?? "/"}
                  className="flex w-full items-center py-2 text-lg font-semibold"
                  onClick={() => setSheetOpen(false)}
                  prefetch={false}
                >
                  {item.title}
                </Link>
              )}
              {/* Render sub-items inside the mobile menu */}
              {/* {item.subItems?.items?.map((subItem) => (
									<Link
										key={subItem.name}
										href={subItem.href}
										className="flex w-full items-center pl-6 py-2 text-sm font-normal"
										prefetch={false}
									>
										{subItem.name}
									</Link>
								))} */}
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
